import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../common/modal";
import api from '../../../services/axios';
import Swal from "sweetalert2";
import { useJWTAuth } from '../../../services/JWTAuthProvider';

const CreateFolder = ({ isPublic, folderId, isOpen, closeCallback, successCallback }) => {

    const { refreshFolders } = useJWTAuth();
    const [inputValue, setInputValue] = useState('');
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleclose = () => {
        setInputValue('');
        closeCallback();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubBtnDisabled(true);
        setInputValue('');

        if (!inputValue) {
            Swal.fire({
                position: "center",
                icon: "info",
                text: folderId == null ? 'Business Unit name is required':'Folder name is required',
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true
            });
            setSubBtnDisabled(false);
            return;
        }
        

        try {
            const { data } = await api.post("/folders", {
                name: inputValue,
                parentFolderGuid: folderId,
                isPublic: isPublic
            });
            if (data.statusCode === 200) {
                refreshFolders();
                if (successCallback)
                    successCallback(folderId);
                setInputValue('');
                closeCallback();
                Swal.fire({
                    position: "center",
                    icon: "success",
                    text: folderId == null ? 'Business Unit created successfully':'Folder created successfully',
                    showConfirmButton: true,
                    timer: 3000,
                    timerProgressBar: true
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setInputValue('');
        setSubBtnDisabled(false);
    }
    return (
        <Modal isLarge={false} isOpen={isOpen}>
            <ModalHeader>
                <h5 className="modal-title">
                    <img src="/Assets/upload.svg" alt="Add Files" /> {folderId ? 'Create Folder' : 'Create Business Unit'}
                </h5>
            </ModalHeader>
            <ModalBody>
                <label className="folder-btm-text">{folderId ? 'Folder Name' : 'Business Unit Name'}</label>
                <input
                    type="text"
                    className="form-control folder-textbox"
                    placeholder={folderId ? 'Enter Folder Name' : 'Enter Business Unit Name'}
                    value={inputValue}
                    onChange={handleInputChange}
                />
            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleclose}
                >
                    Cancel
                </button>
                <button disabled={subBtnDisabled} type="button" onClick={handleSubmit} className="btn btn-primary">
                    Create
                </button>
            </ModalFooter>
        </Modal>);
};
export default CreateFolder;